export const MESSAGE_STANDARD_INFO = 'Hello, welcome to our Customer Service online chat. ' +
    'I would like to mention that the chat is monitored and recorded for quality assurance.';

export const MESSAGE_BON_SECOURS_ORDERS = "Hello, this is Bon Secours's virtual assistant.";

export const MESSAGE_MERCY_HEALTH_ORDERS = "Hello, this is Mercy Health's virtual assistant.";

export const MESSAGE_NO_AGENTS_AVAILABLE_DEFAULT = "We're very sorry, but all or our agents are assisting other patients right now. " +
    "Please try again in a few minutes.";

export const MESSAGE_NO_AGENTS_AVAILABLE_ORDERS = "We're sorry, all of our agents are currently serving other customers, please try again later.";

export const MESSAGE_NO_AGENTS_AVAILABLE_BS = "We're very sorry, but all or our agents are assisting other patients right now. " +
    "Please try again in a few minutes or visit " +
    "<a href=\"https://www.bonsecours.com/about-us/contact-us\">Contact Us | Bon Secours</a> " +
    "for additional options to service your account.";

export const MESSAGE_NO_AGENTS_AVAILABLE_MH = "We're very sorry, but all or our agents are assisting other patients right now. " +
    "Please try again in a few minutes or visit " +
    "<a href=\"https://www.mercy.com/contact-us\">Contact Us | Mercy Health</a> " +
    "for additional options to service your account.";


export const BON_SECOURS = 'Bon Secours - ';
export const MERCY_HEALTH = 'Mercy - ';

export const QUEUE_NAME_BON_SECOURS_SERVICE = 'Bon Secours - CS';
export const QUEUE_NAME_BON_SECOURS_ORDERS = 'Bon Secours - Orders';
export const QUEUE_NAME_MERCY_HEALTH_SERVICE = 'Mercy - CS';
export const QUEUE_NAME_MERCY_HEALTH_ORDERS = 'Mercy - Orders';

export const QUEUE_TYPE_DEFAULT = 0;
